import type { Project } from '@finsim/model';
import { apiFetch } from './http';

/** Server-side project metadata (apps/api projects routes). */
export interface RemoteMeta {
  id: string;
  name: string;
  version: number;
  contentHash: string;
  createdAt: number;
  updatedAt: number;
  deletedAt: number | null;
}

export const remoteProjects = {
  list: (trash = false) =>
    apiFetch<{ projects: RemoteMeta[] }>(`/projects${trash ? '?trash=1' : ''}`).then(
      (r) => r.projects,
    ),
  /** Unvalidated JSON: callers run it through `parseProject`. */
  get: (id: string) =>
    apiFetch<{ project: unknown; meta: RemoteMeta }>(`/projects/${encodeURIComponent(id)}`),
  create: (project: Project) =>
    apiFetch<{ project: RemoteMeta; duplicateOf?: string }>('/projects', {
      method: 'POST',
      json: { project },
    }),
  update: (project: Project, version: number) =>
    apiFetch<{ meta: RemoteMeta }>(`/projects/${encodeURIComponent(project.id)}`, {
      method: 'PUT',
      json: { project },
      headers: { 'If-Match': `"${String(version)}"` },
    }),
  remove: (id: string) =>
    apiFetch<undefined>(`/projects/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  restore: (id: string) =>
    apiFetch<{ meta: RemoteMeta }>(`/projects/${encodeURIComponent(id)}/restore`, {
      method: 'POST',
    }),
};
